import { Controller } from "stimulus"

const timeExpando = "__transcript_start_end"

function stepMatchesTime(el, ts) {
  const [ start, end ] = el[timeExpando]
  return start <= ts && ts <= end
}

export default class extends Controller {
  static targets = [ "step" ]
  static classes = [ "toggle" ]

  connect() {
    const [ first ] = this.stepTargets
    this._currentStep = first
    this._updating = false
  }

  stepTargetConnected(el) {
    try {
      if (!el[timeExpando]) {
        el[timeExpando] = JSON.parse(el.dataset.time)
      }
    } catch {
      // no-op
    }
  }

  handle({ detail: { audioTag } }) {
    window.requestAnimationFrame(() => {
      this.requestNextStep(audioTag.currentTime)
    })
  }

  requestNextStep(ts) {
    const [ firstStep, ...steps ] = this.stepTargets
    const nextStep = steps.find(el => stepMatchesTime(el, ts))

    if (nextStep) {
      this.activateStep(nextStep)
    }

    if (this.reachedEnd(ts)) {
      this.activateStep(firstStep)
    }
  }

  activateStep(el) {
    this._currentStep.classList.add(this.toggleClass)
    el.classList.remove(this.toggleClass)
    this._currentStep = el
  }

  reachedEnd(ts) {
    const lastStep = this.stepTargets[this.stepTargets.length - 1]
    const [ , limit ] = lastStep[timeExpando]

    return ts > limit
  }
}
